import './index.scss'

jQuery(($) => {
  function initializeRecentPostsCarousel() {
    const $carousels = $('.carousel--recent-posts')

    function toggleCarousel() {
      $carousels.each((index, carousel) => {
        const $carousel = $(carousel)

        if ($(window).width() < 992) {
          if (!$carousel.hasClass('owl-loaded')) {
            $carousel.owlCarousel({
              items: 1,
              nav: false,
              dots: false,
              loop: false,
              mouseDrag: true,
              touchDrag: true,
              stagePadding: 30
            })
          }
        } else {
          if ($carousel.hasClass('owl-loaded')) {
            $carousel.trigger('destroy.owl.carousel')
            $carousel.removeClass('owl-loaded')
            $carousel.find('.owl-stage-outer').children().unwrap()
            $carousel.find('.owl-stage').children().unwrap()
          }
        }
      })
    }

    toggleCarousel()

    $(window).on('resize', toggleCarousel)
  }

  initializeRecentPostsCarousel()
})
